module.exports = __webpack_public_path__ + "static/media/1008198.2c67a80f.png";